import { useState } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'

import RembleLogomark from '../../../../assets/images/Remble_Logomark-Green.png'

/**
 * Dismissable alert component. Used for displaying alerts that can be dismissed.
 */
export default function AlertDismissable({
  variant = 'success',
  defaultShow = true,
  title,
  message,
  onDismiss,
  children,
  dismissable = true
}) {
  const [show, setShow] = useState(defaultShow)

  return (
    <Alert show={show} variant={variant}>
      <Alert.Heading>{title}</Alert.Heading>
      {message && <p>{message}</p>}
      {children}
      <hr />
      <Row>
        <Col>
          <img
            className='logomark mt-2'
            src={RembleLogomark}
            alt='Remble'
            width='25'
            loading='lazy'
          />
        </Col>
        <Col className='text-right'>
          {dismissable && (
            <Button
              className='px-5'
              onClick={() => {
                setShow(false)
                // onDismiss Callback
                onDismiss && onDismiss()
              }}
              variant='outline-primary'
            >
              Ok
            </Button>
          )}
        </Col>
      </Row>
    </Alert>
  )
}
